import { SearchFormConfig } from '@awazevr/design-system.compositions.search-form'
import { getExperimentVariationKey } from '@awazevr/mfe-common.lib.optimizely'

import { OPTIMIZELY_FLAGS_ENUM } from 'src/constants'
import { OptimizelyData } from 'src/types'

export const LODGES_AND_PARKS_LABEL = 'Lodges and Parks'
const HOLIDAY_PARKS_VALUE = 'holiday-parks'

export const isInLodgesAndParksRenameExp = (
  optimizelyData: OptimizelyData | undefined,
): boolean => {
  if (optimizelyData?.decisions === undefined) {
    return false
  }

  return (
    getExperimentVariationKey(
      optimizelyData.decisions,
      OPTIMIZELY_FLAGS_ENUM.HOS_LODGES_AND_PARKS_RENAME,
    ) === 'variant_a'
  )
}

export const applyLodgesAndParksRename = <T extends SearchFormConfig>(
  config: T,
  optimizelyData: OptimizelyData | undefined,
): T => {
  if (
    !config.accommodationType ||
    !isInLodgesAndParksRenameExp(optimizelyData)
  ) {
    return config
  }

  return {
    ...config,
    accommodationType: {
      ...config.accommodationType,
      options: (config.accommodationType.options ?? []).map((group) => ({
        ...group,
        options: group.options.map((option) =>
          option.value === HOLIDAY_PARKS_VALUE
            ? { ...option, text: LODGES_AND_PARKS_LABEL }
            : option,
        ),
      })),
    },
  } as T
}
